import React from 'react'
import DistributorLogo from './assets/distributor.png'
import NetCoLiteLogo from './assets/netcolite.png'

function PageHeader({ landingName }) {
  const logo = landingName === 'distributor' ? DistributorLogo : NetCoLiteLogo
  return (
    <header className="px-8 d-flex background-white">
      <img src={logo} className="new-landing-logo" alt="" />
    </header>
  )
}

export default PageHeader



// WEBPACK FOOTER //
// ./src/components/newLayout/PageHeader.js